import type { AnswerFragment } from '../../../present/activity-answers.graphql.generated';
import { DropItem } from 'approot/activity-builder/components/shared/interactive-drag-drop/interactive-drag-drop.constants';
import { InteractiveResponseCategoriseItem } from './interactive-response-categorise.constants';
import { DropItem as DropItemSmall } from './play/interactive-response-categorise-small.constants';
import type { Pluck } from 'lib/gql/pluck';

export function prepareItemsForSave(
  dropItems: DropItem[],
  items: InteractiveResponseCategoriseItem[]
) {
  const answerItems: Pluck<
    Extract<
      Pluck<AnswerFragment, 'answer'>,
      { __typename: 'InteractiveResponseAnswer' }
    >,
    'interactiveResponseItems'
  >[] = [];

  for (let i = 0; i < dropItems.length; i++) {
    const dropItem = dropItems[i];
    for (let j = 0; j < dropItem.zones.length; j++) {
      const zone = dropItem.zones[j];
      if (zone.dragItemId) {
        answerItems.push({
          __typename: 'InteractiveResponseAnswerItem',
          dropZoneId: dropItem.id,
          imageId: zone.dragItemId || '',
          isCorrect: items.some(
            item =>
              item.itemId === zone.dragItemId && item.categoryId === dropItem.id
          ),
        });
      }
    }
  }

  return answerItems;
}

export function prepareSmallItemsForSave(dropItems: DropItemSmall[]) {
  const answerItems: Pluck<
    Extract<
      Pluck<AnswerFragment, 'answer'>,
      { __typename: 'InteractiveResponseAnswer' }
    >,
    'interactiveResponseItems'
  >[] = [];

  for (const dropItem of dropItems) {
    for (const dragItem in dropItem.dragItems) {
      if (dragItem) {
        answerItems.push({
          __typename: 'InteractiveResponseAnswerItem',
          dropZoneId: dropItem.id,
          imageId: dragItem || '',
          isCorrect: dropItem.dragItems[dragItem].isCorrect || false,
        });
      }
    }
  }

  return answerItems;
}
